import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBuilding2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], _ = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.285 1.519A1.19 1.19 0 0 0 8 1.5H4.5c-.067 0-.255 0-.442.004a7.218 7.218 0 0 0-.258.01l-.094.007H3.7a.238.238 0 0 0-.177.18l-.004.014A1.19 1.19 0 0 0 3.5 2v8.5h5V2c0-.144-.002-.223-.02-.294L8.478 1.7a.239.239 0 0 0-.179-.177l-.014-.004ZM9.5 5v5.5h.5a.5.5 0 0 0 .5-.5V5.5c0-.15-.003-.221-.019-.285a.282.282 0 0 0-.07-.131.272.272 0 0 0-.116-.062A1.2 1.2 0 0 0 10 5h-.5Zm0-1V1.984c0-.126 0-.318-.05-.517a1.239 1.239 0 0 0-.922-.918A2.055 2.055 0 0 0 8.017.5H4.5c-.068 0-.266 0-.465.005-.1.002-.204.005-.295.01a1.239 1.239 0 0 0-1.191.956A2.055 2.055 0 0 0 2.5 2v3.5h-.517c-.125 0-.32 0-.518.051a1.28 1.28 0 0 0-.589.33 1.274 1.274 0 0 0-.33.607 2.2 2.2 0 0 0-.046.52V10c0 .826.674 1.5 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5V5.483c0-.13 0-.32-.051-.518a1.28 1.28 0 0 0-.33-.589 1.274 1.274 0 0 0-.607-.33A2.2 2.2 0 0 0 9.992 4H9.5Zm-7 2.5H2a1.19 1.19 0 0 0-.285.019.282.282 0 0 0-.131.07.271.271 0 0 0-.062.116A1.2 1.2 0 0 0 1.5 7v3c0 .274.226.5.5.5h.5v-4Zm2-3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
], f = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, H, d, A, I, t) {
  return r(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--building-2"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Building 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, f)
    ])
  ], 10, h);
}
const z = /* @__PURE__ */ s(c, [["render", v]]);
export {
  z as default
};
//# sourceMappingURL=building-2.js.map
